import axios from 'axios';

// ==== CONFIGURATION ====

// API base with versioning
const rawBaseURL =
 // process.env.REACT_APP_API_BASE_URL || 'https://api.4xbiz.com/api/v1'; this is the old
 process.env.REACT_APP_API_BASE_URL ||
  (process.env.NODE_ENV === "production"
    ? "https://api.4xbiz.com/api/v1"
    : "/api");
    // end new code
const baseURL = rawBaseURL.replace(/\/$/, '');

// Toast handler for errors
let apiGlobalErrorHandler = (msg, type = 'error') => {};
export function setApiGlobalErrorHandler(cb) {
  apiGlobalErrorHandler = cb;
}

// ==== AXIOS INSTANCE ====
const api = axios.create({
  baseURL,
  withCredentials: true,
  timeout: 10000,
});

// ==== TOKEN REFRESH LOCK (No infinite loops!) ====
let isRefreshing = false;
let refreshFailed = false;
let refreshSubscribers = [];
function subscribeTokenRefresh(cb) {
  refreshSubscribers.push(cb);
}
function onRefreshed(token) {
  refreshSubscribers.forEach((cb) => cb(token));
  refreshSubscribers = [];
}

// Ensure login redirect only triggers once
let hasRedirected = false;

// ==== REQUEST INTERCEPTOR ====
api.interceptors.request.use(
  (config) => {
    // Get the token from either localStorage or sessionStorage
    const token =
      localStorage.getItem('accessToken') ||
      sessionStorage.getItem('accessToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ==== RESPONSE INTERCEPTOR ====
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    // If a refresh failed this session, do NOT try again
    if (refreshFailed) return Promise.reject(error);

    const originalRequest = error.config;
    if (!originalRequest) return Promise.reject(error);

    // Never run refresh logic on auth pages
    const authPaths = ['/login', '/signup', '/auth', '/forgot'];
    const isOnAuthPage = authPaths.some((p) =>
      window.location.pathname.startsWith(p)
    );

    // ---- 401: Attempt token refresh (only once per session) ----
    if (
      error.response?.status === 401 &&
      !originalRequest._retry &&
      !isOnAuthPage
    ) {
      originalRequest._retry = true;

      if (isRefreshing) {
        // Queue requests during token refresh
        return new Promise((resolve, reject) => {
          subscribeTokenRefresh((newToken) => {
            if (newToken) {
              originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
              resolve(api(originalRequest));
            } else {
              reject(error);
            }
          });
        });
      }

      isRefreshing = true;
      try {
        const { data } = await axios.post(
          `${baseURL}/auth/refresh-token`,
          {},
          { withCredentials: true }
        );
        if (localStorage.getItem('accessToken')) {
  localStorage.setItem('accessToken', data.accessToken);
} else if (sessionStorage.getItem('accessToken')) {
  sessionStorage.setItem('accessToken', data.accessToken);
} else {
  localStorage.setItem('accessToken', data.accessToken);
}
        originalRequest.headers['Authorization'] = `Bearer ${data.accessToken}`;
        onRefreshed(data.accessToken);
        isRefreshing = false;
        return api(originalRequest);
      } catch (refreshError) {
        isRefreshing = false;
        onRefreshed(null);
        localStorage.removeItem('accessToken');
        refreshFailed = true; // Never try again until reload

        // Prevent double window.location redirects!
        if (!hasRedirected) {
          hasRedirected = true;
          apiGlobalErrorHandler('Session expired, please log in again.', 'error');
          setTimeout(() => {
            window.location.href = '/login';
          }, 100); // Slight delay for toast to show
        }
        return Promise.reject(refreshError);
      }
    }

    // 401 on an auth page: just reject (do not retry)
    if (error.response?.status === 401 && isOnAuthPage) {
      return Promise.reject(error);
    }

    // ==== All other errors: Global toast ====
    if (error.response && error.response.data && error.response.data.message) {
      apiGlobalErrorHandler(error.response.data.message, 'error');
    } else if (error.message) {
      apiGlobalErrorHandler(error.message, 'error');
    } else {
      apiGlobalErrorHandler('An unknown API error occurred.', 'error');
    }

    return Promise.reject(error);
  }
);

export default api;
